import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const FieldsList = ({ data, loading, error, siteId }) => {
  const [selectedFields, setSelectedFields] = useState([]);
  const navigate = useNavigate();

  // Toggle selection of a field
  const handleFieldToggle = (fieldId) => {
    setSelectedFields((prevSelected) =>
      prevSelected.includes(fieldId)
        ? prevSelected.filter((id) => id !== fieldId)
        : [...prevSelected, fieldId]
    );
  };

  // Proceed to the new URL with selected fields
  const handleProceed = () => {
    if (selectedFields.length > 0) {
      const queryParams = selectedFields.join(",");
      navigate(`/tv/fields/${siteId}/field/${queryParams}`);
    } else {
      alert("Please select at least one field to proceed.");
    }
  };

  // Render loading state
  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center space-y-2">
        <div className="animate-spin rounded-full border-4 border-t-4 border-gray-500 w-16 h-16"></div>
        <p className="text-lg">Loading Fields...</p>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="text-center text-red-500">
        <p className="text-lg">{error}</p>
      </div>
    );
  }

  // Render fields list as cards if data is available
  if (data && data.length > 0) {
    return (
      <div>
        <div className="flex flex-wrap justify-around">
          {data.map((field) => (
            <div
              key={field._id}
              className={`bg-white rounded-lg shadow-lg w-72 m-4 cursor-pointer ${
                selectedFields.includes(field._id)
                  ? "border-2 border-blue-500"
                  : ""
              }`}
              onClick={() => handleFieldToggle(field._id)}
            >
              <div className="p-4">
                <h3 className="text-xl font-semibold">{field.name}</h3>
                <h4 className="text-gray-600 font-semibold">
                  Shelves: <b>{field.shelves.length}</b>
                </h4>
                <p>
                  <ul>
                    {field.shelves.map((shelf, index) => (
                      <li key={`sendor-${shelf.sensorId}`}>
                        {/* {shelf?.sensor?._id} */}
                        {shelf?.sensor?.boardId}
                      </li>
                    ))}
                  </ul>
                </p>
                <p className="text-gray-600">Cameras: {field.cameras.length}</p>
              </div>
              <div className="p-4 border-t">
                <button
                  className="text-blue-600 hover:text-blue-800 text-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onCardClick(field);
                  }}
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-4">
          <button
            className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
            onClick={handleProceed}
          >
            Proceed with Selected ({selectedFields.length})
          </button>
        </div>
      </div>
    );
  }

  // Render message when no fields are available
  return (
    <div className="text-center">
      <p className="text-lg">No Fields Available</p>
    </div>
  );
};

export default FieldsList;
